<div class="cb-margin-bottom cb-margin-top end-center flex-row">
    @if (!questions?.length) {
        <span class="cb-margin-left start-center flex-row flex">
            <mat-icon color="accent">info</mat-icon>
            <span class="mat-body-2">&nbsp;There are no Questions for this item</span>
        </span>
    }
    <button
        mat-raised-button
        class="cb-margin-right"
        color="primary"
        (click)="createQuestion()"
        [disabled]="!edit"
    >
        New Question
    </button>
</div>
<div class="flex-col">
    <mat-divider></mat-divider>
    @for (question of questions | cbSortByPipe: 'questionNumber' : 'desc'; track question) {
        <cb-generic-question-item
            [ngClass]="{ 'highlighted-question': question.questionNumber === questionNumber }"
            [genericQuestion]="question"
            [questionNumber]="questionNumber"
            [childItemLabel]="childItemLabel"
            [childItems]="childItems"
            [entityId]="entityId"
            [childSystemArea]="childSystemArea"
            [systemArea]="systemArea"
            [edit]="edit"
            class="cb-margin-bottom-2x"
        ></cb-generic-question-item>
    }
</div>
